import React from "react";

import dayjs from "dayjs";
import { Tag, Tooltip } from "antd";
import { ClockCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import 'dayjs/locale/en';
import 'dayjs/locale/tr';

dayjs.locale('tr');

export default ({ date, format = 'fullDate', warning = false, error = false, title = date, bordered = true }) => {
    const intl = useIntl();

    return (
        <Tooltip title={dayjs(title).format(intl.formatMessage({ id: (format === 'fullDate' ? "date.formatAddTime" : "date.format") }))}>
            <Tag icon={warning || error ? <WarningOutlined /> : <ClockCircleOutlined />} color={warning ? 'warning' : error ? 'error' : "default"} bordered={bordered}>
                {dayjs(date).format(intl.formatMessage({ id: "date.format" }))}
            </Tag>
        </Tooltip>
    );
}